import {authQueryOptions} from '@/modules/auth/api'
import {rqContext} from '@/router'
import {hasAnyPermission, type Permission} from '@cypro/engine/utils'
import {redirect} from '@tanstack/react-router'

/** Any of these opens the Configuration area; each sub-page still checks its own permission. */
export const CONFIGURATION_PERMISSIONS = [
  'users.manage',
  'protocols.view',
  'catalogue.view',
  'organisation.manage',
  'interfaces.manage',
  'settings.manage',
  'logs.view',
  'basic_data.manage',
] as const satisfies readonly Permission[]

/** Whether the user may open any Configuration page (rail item, shortcuts, /configuration redirect). */
export function hasConfigurationAccess(permissions: ReadonlySet<Permission>) {
  return CONFIGURATION_PERMISSIONS.some(permission => permissions.has(permission))
}

/** Route guard: a user without any of the permissions lands on Patients with a no-access toast. */
export function requirePermission(...permissions: Permission[]) {
  return () => {
    const auth = rqContext.queryClient.getQueryData(authQueryOptions.queryKey)

    if (!hasAnyPermission(auth?.session?.groups, permissions)) {
      throw redirect({to: '/patient-dashboard/patients', search: {forbidden: true}})
    }
  }
}
